import React from 'react';

function TipoBemModal({ show, onClose, onSubmit, form, handleChange, naturezas = [], title = 'CADASTRO DE TIPO DE BEM' }) {
  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-box me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Natureza *</label>
                <select className="form-select form-select-sm" name="idNatureza" value={form.idNatureza} onChange={handleChange} required>
                  <option value="">Selecione...</option>
                  {naturezas.map(n => <option key={n.id} value={n.id}>{n.descricao}</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Descrição *</label>
                <input type="text" className="form-control" name="descricao" value={form.descricao} onChange={handleChange} required />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TipoBemModal;
